import { makeReactHotToast } from './makeReactHotToast.js';
import { MakeToast } from './types.js';

const useToaster = () => {
  const makeToast: MakeToast = makeReactHotToast;

  return makeToast;
};

export { useToaster };
